export const IS_SYNTHETIC_TRAFFIC_QUERY_PARAM = 'is_pollinator_check';
